import { useSelector } from 'react-redux';

const useGetCarAddOn = () => {
    return useSelector((state) => state.addOn.car_addOn);
};

export default useGetCarAddOn;